import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledIntegrationSetting = styled.div`
    padding: 27px 0;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledDropdownContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;
